/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Tooltip, Typography} from '@mui/material';
import {format, formatDistanceToNow} from 'date-fns';

interface LastUpdatedCellProps {
  updatedAt: number | string | Date;
}

export const LastUpdatedCell = ({updatedAt}: LastUpdatedCellProps) => {
  const date = new Date(updatedAt);

  return (
    <Tooltip
      title={format(date, 'dd/MM/yyyy HH:mm')}
      PopperProps={{
        onClick: (e) => e.stopPropagation(),
      }}
    >
      <Typography>{formatDistanceToNow(date)} ago</Typography>
    </Tooltip>
  );
};
